import { createContext, useContext, useMemo, useState } from 'react';
import { Step } from 'react-joyride';

export interface TutorialState {
  run: boolean;
  stepIndex: number;
  steps: Step[];
  tourActive: boolean;
  callback?: Function;
  alias?: string;
  triggers?: { [key: string]: Function };
}

const tutorialState = {
  run: false,
  stepIndex: 0,
  steps: [],
  tourActive: false,
};

export const TutorialContext = createContext({
  state: tutorialState,
  setState: () => undefined,
});
TutorialContext.displayName = 'TutorialContext';

export function TutorialProvider(props: any) {
  const [state, setState] = useState(tutorialState);

  const value = useMemo(
    () => ({
      state,
      setState,
    }),
    [setState, state]
  );

  return <TutorialContext.Provider value={value} {...props} />;
}

export function useTutorialContext(): {
  setState: (
    patch:
      | Partial<TutorialState>
      | ((previousState: TutorialState) => Partial<TutorialState>)
  ) => void;
  state: TutorialState;
} {
  const context = useContext(TutorialContext);

  if (!context) {
    throw new Error(
      'useTutorialContext must be used within a TutorialProvider'
    );
  }

  return context;
}
